import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Renderdevice from "../../components/carpark/renderbooking";

//import {getdevice,getfacesite,getfacegroup} from '../../services/facescan';
import { getBookinglist,getreportpbx } from "../../services/car";
import BranchContext from "../context/branch";
import Input from "../common/inputfunction";
import PrivilegeContext from "../context/privilege";
import ScrollToTop from "../common/ScrollToTop";
import DatePicker from "react-datepicker";
const Reportpbx = (props) => {
  const { menuItems } = useContext(PrivilegeContext);
  const { currentBranch } = useContext(BranchContext);
  const [search, setsearch] = useState("");
  const [name, setname] = useState("");
  const [lastupdate, setlastupdate] = useState(new Date());
  const [groupid, setgroupid] = useState(0);
  const [month, setmonth] = useState(0);
  const [id, setid] = useState(0);
  const [yearid, setyearid] = useState(2021);
  //const [value, setValue] = useState([1]);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [vload, setvload] = useState(false);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(0);
  const [bookinglist, setbookinglist] = useState([]);
  const [billlist, setbilllist] = useState([]);
  const [grouplist, setgrouplist] = useState([]);
  const [yearlist, setyearlist] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const [data, setdata] = useState([]);
  const [messageerror, setmessageerror] = useState("");
  const [header, setheader] = useState("");
  const [showonscroll, setshowonscroll] = useState(false);
  const [showprogress, setshowprogress] = useState(false);
  const [completed, setcompleted] = useState(50);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  useEffect(() => {
    if (!currentBranch) return;
    if (!menuItems) return;
    if (!pageSize) return;

    setbookinglist([]);
  }, [currentBranch, search, pageSize, lastupdate, showonscroll, menuItems]);

  useEffect(() => {
    if (!currentBranch) return;

    if (!pageSize || !pageNumber) return;
    if (!menuItems) return;
    if (menuItems.length === 0) return;

    setLoading(true);
    setError(false);
    // setshowprogress(true)
    const loadData = async () => {
      const { data: result } = await getBookinglist(
        search,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        setTotal(result.data.total);
        //  setshowprogress(false)
        setbookinglist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      } else if (
        result.status === "error" &&
        result.message === "invalid token"
      ) {
        const urlGoBack = "logout";
        setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };
    loadData();
  }, [currentBranch, search, pageSize, pageNumber, showonscroll, menuItems]);
  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getreportpbx();

      // getStore(( currentBranch._id)).then (result=>{
      //   setstoreList(result.data);
      // if (result) {
      //   setstoreList(result);
      // }
    };
    loadData();

    //  });
  }, [startDate]);
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handlegroupChange = (event) => {
    setgroupid(event.currentTarget.value);
    setsearch(name);
    setPageNumber(1);
  };

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);
    setsearch(name);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setPageNumber(1);
      setsearch(name);
    }
  };

  const handleOnClick = (id, action) => {
    setmonth(action);
    setid(id);
    setisOpen(true);
  };

  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };

  const handlemodalTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleSearchClick = () => {
    setPageNumber(1);
    setsearch(name);
  };

  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };

  // console.log(billlist)

  const handleCancleSubmit = () => {
    setisOpen(false);
  };
  const handleConfirmSubmit = () => {
    setisOpen(false);
  };
  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  return (
    
    <>
      <div className="container">
        <div className="row">
        <div className="col-auto">
            <i>
              จากวันที่ <span className="label label-default"></span>
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>
          <div className="col-auto">
            <i>
              ถึงวันที่ <span className="label label-default"></span>
            </i>
            <div className="mt-1">
              <DatePicker
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={endDate}
                onChange={handleChangEndDate}
              />
            </div>
          </div>
          <div className="col-lg-6  col-sm-10 col-xs-12">
            <div className="form-group">
              <Input
                name="name"
                value={name}
                label="ค้นหา"
                placeholder="ชื่อ สกุล"
                onChange={handleTextchange}
                onClick={handleSearchClick}
                onKeyPress={handleKeyPress}
                search="ค้นหา"
              />
            </div>
          </div>
        </div>
        {/* <Header onChange={handleChange} handleDateChange={handleDateChange} /> */}
      </div>

      <div className="container">
        <div className="row m-1">
          <div className="col-lg-4  col-sm-6 col-xs-12">
            <span className="text-success">
              แสดงข้อมูล {bookinglist ? bookinglist.length : 0} / {total} รายการ
            </span>
          </div>
        </div>
      </div>

      {/* { showprogress && <ProgressBar bgcolor={"#6a1b9a"} completed={completed} />} */}
      {<ScrollToTop onClick={scrollToTop} />}

      <Renderdevice
        list={bookinglist}
        handleOnClick={handleOnClick}
        error={error}
        lastBookElementRef={lastBookElementRef}
      />
    </>
  );
};

export default Reportpbx;
